
















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import {
  ICheckoutCartEarlyRenewalContract,
  ICheckout
} from '@/interfaces/Checkout';

const CheckoutModule = namespace('App/Checkout');

@Component
export default class EarlyRenewal extends Vue {
  @CheckoutModule.State(state => state.checkout)
  private checkout: ICheckout;

  private pattern: object = { pattern: 'dd/MM/yyyy' };

  private get cart() {
    return this.checkout.cart;
  }
}
